/**
 * The mutation whose callback is running right now (#1628-b).
 *
 * `useMutation` from `@/api/mutation` runs the caller's `onError` / `onSuccess` /
 * `onSettled` (options and per-call) inside `runWithFeedbackSource(key, …)`, so
 * a `reportMutationError` written in them is sourced by the mutation's key
 * without the site passing it, and a later success of the same mutation clears
 * it. The scope is the synchronous duration of the callback only and is always
 * restored. No imports: `reportMutationError.ts` reads it and must not pull in
 * the wrapper.
 */
let current: string | undefined;

export function runWithFeedbackSource<T>(key: string, fn: () => T): T {
  const previous = current;
  current = key;
  try {
    return fn();
  } finally {
    current = previous;
  }
}

export function currentFeedbackSource(): string | undefined {
  return current;
}
